"use client";

import { cn } from "@/lib/utils";
import { useFallbackTrigger } from "./useFocusAfterFallback";
import { MenuMoreGlyph } from "./MenuParts";
import { MENU_TRIGGER_CLASS } from "./menu.constants";
import { createLazyOverlay } from "./createLazyOverlay";
import type { ComponentProps, ComponentPropsWithRef, ReactElement } from "react";
import type { MenuPanel as MenuPanelComponent } from "./MenuPanel";
export { MenuSectionLabel } from "./MenuParts";
export type { MenuItem } from "./MenuParts";
export type RenderMenuTrigger = (attrs: ComponentPropsWithRef<"button">) => ReactElement;
type MenuProps = Omit<ComponentProps<typeof MenuPanelComponent>, "fallbackRef" | "renderTrigger"> & {
  trigger?: React.ReactNode;
  triggerClassName?: string;
};
const LazyMenuPanel = createLazyOverlay<ComponentProps<typeof MenuPanelComponent> & {
  fallbackHandlers: ReturnType<typeof useFallbackTrigger>["fallbackHandlers"];
}>({
  name: "menu",
  load: () => import("./MenuPanel"),
  exportName: "MenuPanel",
  renderFallback: props => <span className={cn("relative block", props.className)}>
            {props.renderTrigger({
      ...props.fallbackHandlers,
      "aria-haspopup": "menu",
      // boolean-naming-exempt: external contract — ARIA attribute name
      "aria-expanded": false
    })}
        </span>
});
export function Menu(props: MenuProps) {
  const {
    fallbackRef,
    fallbackHandlers
  } = useFallbackTrigger();
  const renderTrigger: RenderMenuTrigger = attrs => <button type="button" aria-label={props.label} disabled={props.disabled} className={cn(MENU_TRIGGER_CLASS, props.triggerClassName)} {...attrs} data-sentry-component="renderTrigger" data-sentry-source-file="Menu.tsx">
            {props.trigger ?? <MenuMoreGlyph />}
        </button>;
  return <LazyMenuPanel {...props} fallbackRef={fallbackRef} fallbackHandlers={fallbackHandlers} renderTrigger={renderTrigger} data-sentry-element="LazyMenuPanel" data-sentry-component="Menu" data-sentry-source-file="Menu.tsx" />;
}